export default {
  primaryColor: '#F5222D', // 主体颜色
  title: '北斗高精度服务平台',
  // 表格相关设置
  tableSetting: {
    formSetting: {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    },
  },
};
